import React from "react";
import Sidebar from "../dashboard/Sidebar";

const Settings = () => {
  return (
    <div className="component-main">
      <Sidebar active="settings" />
      <p>Settings Component</p>
    </div>
  );
};

export default Settings;
